export default __webpack_public_path__ + "static/media/darklogo.18a33fac.svg";